import React, { lazy, Suspense } from 'react'
import componentLoader from '../../utilities/componentLoader'

const ServiceProviders = lazy(() => componentLoader(() => import('./components/ServiceProviders')))

export default () => (
	<div data-testid="service-provider">
		<Suspense fallback={<div />}>
			<section>
				<ServiceProviders />
			</section>
		</Suspense>
	</div>
)
